var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"m-the-modal-shadow",on:{"click":function($event){$event.preventDefault();return _vm.$modal.closeModal.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }